<template>
  <div
    style="min-width:12vw;min-height:25vh;position:absolute;top:19%;left: 50px;z-index:9999;
    background-color: rgba(7,35,59,.5);border-radius: 4px"
    :style="{left: positionLeft}"
    v-if="divVisible">

    <!-- 弹窗主体内容 -->
    <div style="height: 100%;width: 100%;">
      <clouded-glass>
        <div slot="content" style="height: 500px">
          <div>
            <div style="text-align: center; height: 30px">
              <i @touchstart="divClose" @click="divClose" class="el-icon-close close-btn" style="float: right;padding-right: 5px;padding-top: 5px"></i>
              <div style="padding-top: 10px">
                <span style="font-size: 15px;font-weight: bold; color: rgb(40,150,217);padding-left: 15px">设备分类</span>

              </div>
            </div>
            <div style="width: 60%">
              <div class="screen-checkbox" v-for="(item,index) in data" :key="index">
                <el-checkbox v-model="item.show" @change="checkDevice">{{ item.typeCnName }}</el-checkbox>
              </div>

            </div>
          </div>
        </div>
      </clouded-glass>
    </div>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";
import {getDeviceListBySpaceIdAndCategoryTagId} from "@/network/device-info";

export default {
  name: "screenDetail",
  components: {CloudedGlass},
  props: {
    divVisible: {
      type: Boolean,
      default: () => false
    },
    spaceId: {
      type: String,
      default: () => ''
    },
    tagId: {
      type: String,
      default: () => ''
    },
    positionLeft: {
      type: String,
      default: () => '23%'
    }
  },
  watch: {
    spaceId() {
      this.getData();
    },
    tagId() {
      this.getData();
    },
  },
  data() {
    return {
      data: [

      ],
      info:[]
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    divClose() {
      this.$emit("screenDialog")
    },
    getData() {
      if (this.spaceId == null || this.spaceId === ''){
        return ;
      }
      if (this.tagId == null || this.tagId === ''){
        return ;
      }
      this.data=[];
        getDeviceListBySpaceIdAndCategoryTagId(this.spaceId, this.tagId, null).then(res => {
          if (res.code === 0) {
            res.data.forEach(item =>{
                if (item.portProperties === null){
                  return ;
                }
                let result =true;
                this.data.forEach(e => {
                  if (e.typeCnName === item.typeCnName){
                    result=false;
                  }
                })
                if (result){
                  item.show=true;
                  this.data.push(item);
                }
              }
            );
            this.checkDevice();
          }
        })
    },
    checkDevice(){
      this.info=[];
      this.info=this.data.filter(item => item.show == false);
        this.$emit('screenData', this.info)
    }
  }
}
</script>

<style scoped>
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: rgba(0, 0, 0, 0.1);
  border-color: rgb(6, 222, 240);

}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgb(6, 222, 240);
}

::v-deep .el-checkbox__label {
  display: inline !important;
  padding-left: 5px;
}

::v-deep .el-checkbox__inner::after {
  border: 1px solid rgb(6, 222, 240);
  border-left: 0;
  border-top: 0;
}

::v-deep .el-checkbox__inner {
  margin-top: -2px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.1);
}

.screen-checkbox {
  margin-top: 10px;
  margin-left: 35px;
}
</style>
